import React, { useEffect, useRef } from "react";

export const ADSENSE_CLIENT = "ca-pub-1442066771496582";

// Ad Unit slots (from the user's AdSense account)
export const AD_SLOTS = {
  stickyBottom: "4448809606", // Banda Bassa (sticky footer)
  multiplex: "8945196037", // Banda Multi (durante i caricamenti)
  editorVertical: "7073711163", // Banda Vert (editor PDF, laterale)
};

// Generic AdSense <ins> unit. The adsbygoogle.js loader is included in public/index.html.
export const AdSenseUnit = ({ slot, style, format, responsive = false, testId }) => {
  const pushed = useRef(false);

  useEffect(() => {
    if (pushed.current) return;
    pushed.current = true;
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (_) {
      // adsbygoogle.js not loaded yet (blocked / non-approved preview domain):
      // the empty slot stays and fills on the live domain.
    }
  }, []);

  const insProps = {
    className: "adsbygoogle",
    style: style || { display: "block" },
    "data-ad-client": ADSENSE_CLIENT,
    "data-ad-slot": slot,
  };
  if (format) insProps["data-ad-format"] = format;
  if (responsive) insProps["data-full-width-responsive"] = "true";

  return (
    <ins data-testid={testId} {...insProps} />
  );
};
